/**
* description:
* Mutation types for Billing Vuex Module
*
* data : 2017-08-23
*/

export const COMPLETE_BILLING_LIST = 'COMPLETE_BILLING_LIST';
export const CLEAR_BILLING_LIST = 'CLEAR_BILLING_LIST';
export const SET_BILLING_TERMS = 'SET_BILLING_TERMS';



// WEBPACK FOOTER //
// ./src/store/modules/Billing/mutation-types.js